import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const StructuredData = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    // Remove any existing structured data
    const existingScript = document.querySelector('#structured-data');
    if (existingScript) {
      existingScript.remove();
    }

    // Only add structured data for main pages, not policy pages
    if (location.pathname !== '/' && location.pathname !== '/subscribe') {
      return;
    }

    let structuredData = {};

    const organizationSchema = {
      "@type": "Organization",
      "name": "NewsForYou",
      "url": "https://newsforyou.ai",
      "logo": "https://newsforyou.ai/assets/logo.png",
      "description": t('structuredData.organization.description'),
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "contato@newsforyou.ai",
        "contactType": "customer service"
      }
    };

    if (location.pathname === '/') {
      structuredData = {
        "@context": "https://schema.org",
        "@graph": [
          organizationSchema,
          {
            "@type": "SoftwareApplication",
            "name": t('structuredData.homepage.applicationName'),
            "applicationCategory": t('structuredData.homepage.applicationCategory'),
            "operatingSystem": t('structuredData.homepage.operatingSystem'),
            "description": t('structuredData.homepage.description'),
            "url": "https://newsforyou.ai",
            "provider": organizationSchema
          }
        ]
      };
    }

    if (location.pathname === '/subscribe') {
      structuredData = {
        "@context": "https://schema.org",
        "@graph": [
          organizationSchema,
          {
            "@type": "Service",
            "name": t('structuredData.subscribe.name'),
            "description": t('structuredData.subscribe.description'),
            "provider": organizationSchema,
            "brand": {
              "@type": "Brand",
              "name": t('structuredData.subscribe.brand')
            },
            "category": t('structuredData.subscribe.category')
          }
        ]
      };
    }

    // Add structured data to page
    const script = document.createElement('script');
    script.id = 'structured-data';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('#structured-data');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [location.pathname, t]);

  return null;
};

export default StructuredData;